import React, { useRef, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, Typography, Grid, Button, TextField } from '@material-ui/core'
// import Remove from '@material-ui/icons/Remove'
// import Add from '@material-ui/icons/Add'
import Cross from '@material-ui/icons/Delete'

// API
import { putPublicAPI } from '../../api'
import logo from '../../assets/images/logo.jpg'

const MobileCartProduct = props => {
   let mounted = useRef(true)

   const navigate = useNavigate()

   const { product, onRemove, setQuantity, setFeetsInches } = props

   // const onIncrement = async () => {
   //    if (mounted.current) {
   //       if (product.type === 'hose') {
   //          let feetsP = parseInt(product.qty.split('-')[0])
   //          let inchesP = parseInt(product.qty.split('-')[1])

   //          setFeetsInches(product.rhpn, feetsP + 1, inchesP)
   //       } else setQuantity(product.rhpn, product.qty + 1)
   //    }

   //    let productInfo = { pId: product.rhpn, qty: product.qty }

   //    await putPublicAPI('/update-cart-product', {
   //       user: localStorage.user_email,
   //       product: productInfo
   //    })
   // }

   // const onDecrement = async () => {
   //    if (mounted.current) {
   //       if (product.type === 'hose') {
   //          let feetsP = parseInt(product.qty.split('-')[0])
   //          let inchesP = parseInt(product.qty.split('-')[1])

   //          feetsP > 1 && setFeetsInches(product.rhpn, feetsP - 1, inchesP)
   //       } else product.qty > 1 && setQuantity(product.rhpn, product.qty - 1)
   //    }

   //    let productInfo = { pId: product.rhpn, qty: product.qty }
   //    await putPublicAPI('/update-cart-product', {
   //       user: localStorage.user_email,
   //       product: productInfo
   //    })
   // }

   // const onInchIncrement = () => {
   //    let feetsP = parseInt(product.qty.split('-')[0])
   //    let inchesP = parseInt(product.qty.split('-')[1])

   //    if (inchesP >= 11) setFeetsInches(product.rhpn, feetsP + 1, 0)
   //    else setFeetsInches(product.rhpn, feetsP, inchesP + 1)
   // }

   // const onInchDecrement = () => {
   //    let feetsP = parseInt(product.qty.split('-')[0])
   //    let inchesP = parseInt(product.qty.split('-')[1])

   //    if (inchesP === 1 && feetsP === 0) setFeetsInches(product.rhpn, feetsP, 0)
   //    else {
   //       if (inchesP <= 0 && feetsP > 0) setFeetsInches(product.rhpn, feetsP - 1, 11)
   //       else if (inchesP > 0) setFeetsInches(product.rhpn, feetsP, inchesP - 1)
   //    }
   // }

   const updateCartChanges = async () => {
      let productInfo = { pId: product.rhpn, qty: product.qty }
      await putPublicAPI('/update-cart-product', {
         user: localStorage.user_email,
         product: productInfo
      })
   }

   const onQuantityChange = value => {
      setQuantity(product.rhpn, value || 0)
      updateCartChanges()
   }

   const onFeetsChange = value => {
      let inchesP = parseInt(product.qty.split('-')[1])

      setFeetsInches(product.rhpn, value || 0, inchesP || 0)
      updateCartChanges()
   }

   const onInchesChange = value => {
      let feetsP = parseInt(product.qty.split('-')[0])

      setFeetsInches(product.rhpn, feetsP || 0, value || 0)
      updateCartChanges()
   }

   const removeProduct = () => mounted.current && onRemove(product.rhpn)

   useEffect(() => {
      const myQuantity = document.getElementById('quantity-' + product.rhpn)
      if (myQuantity)
         myQuantity.addEventListener('keypress', function (evt) {
            if (evt.which < 48 || evt.which > 57) {
               evt.preventDefault()
            }
         })

      const myFeets = document.getElementById('feets-' + product.rhpn)
      if (myFeets)
         myFeets.addEventListener('keypress', function (evt) {
            if (evt.which < 48 || evt.which > 57) {
               evt.preventDefault()
            }
         })

      const myInches = document.getElementById('inches-' + product.rhpn)
      if (myInches)
         myInches.addEventListener('keypress', function (evt) {
            if (evt.which < 48 || evt.which > 57) {
               evt.preventDefault()
            }
         })

      return () => (mounted.current = false)
   }, [product.rhpn])

   return (
      <Box
         sx={{
            pt: 4,
            alignItems: 'flex-start'
         }}
      >
         <Box sx={{ display: 'flex', pl: 2 }}>
            <img
               className='product-images'
               src={product.pictures.length > 0 ? product.pictures[0] : logo}
               alt={product.rhpn}
            />
            <Button onClick={() => navigate(`/app/product/${product.rhpn}`)}>
               <Typography
                  color='textPrimary'
                  variant='body1'
                  sx={{
                     fontWeight: '600',
                     color: 'grey',
                     pl: 2
                  }}
               >
                  {product.rhpn + ' | ' + product.desc}
               </Typography>
            </Button>
         </Box>
         {product.type === 'hose' ? (
            <Box>
               {/* <Box sx={{ p: 3, pb: 2, display: 'flex', alignItems: 'center' }}>
                  <Typography
                     sx={{
                        fontWeight: '600',
                        color: 'grey'
                     }}
                  >
                     {'Feets: '}
                  </Typography>
                  <Grid
                     container
                     className='qty-product'
                     sx={{ justifyContent: 'center', alignItems: 'center' }}
                  >
                     <Button className='product-actions' item='true' onClick={onDecrement}>
                        <Remove color='action' />
                     </Button>
                     <Grid sx={{ pr: 2, pl: 2 }}>
                        <Typography color='#D22F25' display='inline' variant='body2'>
                           {parseInt(product.qty.split('-')[0])}
                        </Typography>
                     </Grid>
                     <Button className='product-actions' item='true' onClick={onIncrement}>
                        <Add color='action' />
                     </Button>
                  </Grid>
               </Box>
               <Box sx={{ p: 3, pb: 2, display: 'flex', alignItems: 'center' }}>
                  <Typography
                     sx={{
                        fontWeight: '600',
                        color: 'grey'
                     }}
                  >
                     {'Inches: '}
                  </Typography>
                  <Grid
                     container
                     className='qty-product'
                     sx={{ justifyContent: 'center', alignItems: 'center' }}
                  >
                     <Button className='product-actions' item='true' onClick={onInchDecrement}>
                        <Remove color='action' />
                     </Button>
                     <Grid sx={{ pr: 2, pl: 2 }}>
                        <Typography color='#D22F25' display='inline' variant='body2'>
                           {parseInt(product.qty.split('-')[1])}
                        </Typography>
                     </Grid>
                     <Button className='product-actions' item='true' onClick={onInchIncrement}>
                        <Add color='action' />
                     </Button>
                  </Grid>
               </Box> */}
               <Box sx={{ p: 3, pb: 2, display: 'flex', alignItems: 'center' }}>
                  <TextField
                     id={`feets-${product.rhpn}`}
                     label='Feets'
                     fullWidth
                     value={parseInt(product.qty.split('-')[0]) || 0}
                     autoComplete={false}
                     onChange={e => {
                        onFeetsChange(e.target.value)
                     }}
                  />
               </Box>
               <Box sx={{ p: 3, pb: 2, display: 'flex', alignItems: 'center' }}>
                  <TextField
                     id={`inches-${product.rhpn}`}
                     label='Inches'
                     fullWidth
                     value={parseInt(product.qty.split('-')[1]) || 0}
                     autoComplete={false}
                     onChange={e => {
                        onInchesChange(e.target.value)
                     }}
                  />
               </Box>
            </Box>
         ) : (
            <Box sx={{ p: 3, pb: 2, display: 'flex', alignItems: 'center' }}>
               {/* <Typography
                  sx={{
                     fontWeight: '600',
                     color: 'grey'
                  }}
               >
                  {'Quantity: '}
               </Typography>
               <Grid
                  container
                  className='qty-product'
                  sx={{ justifyContent: 'center', alignItems: 'center' }}
               >
                  <Button className='product-actions' item='true' onClick={onDecrement}>
                     <Remove color='action' />
                  </Button>
                  <Grid sx={{ pr: 2, pl: 2 }}>
                     <Typography color='#D22F25' display='inline' variant='body2'>
                        {product.qty}
                     </Typography>
                  </Grid>
                  <Button className='product-actions' item='true' onClick={onIncrement}>
                     <Add color='action' />
                  </Button>
               </Grid> */}
               <Grid
                  container
                  className='qty-product'
                  sx={{ justifyContent: 'center', alignItems: 'center' }}
               >
                  <TextField
                     id={`quantity-${product.rhpn}`}
                     label='Quantity'
                     fullWidth
                     value={product.qty || ''}
                     autoComplete={false}
                     onChange={e => {
                        onQuantityChange(e.target.value)
                     }}
                  />
               </Grid>
            </Box>
         )}
         <Box
            sx={{
               display: 'flex',
               justifyContent: 'space-between',
               alignItems: 'center',
               pl: 2,
               pb: 3
            }}
         >
            <Box>
               <Typography
                  sx={{
                     fontWeight: '600',
                     color: 'grey'
                  }}
               >
                  {'Price: $' + product.lPrice} / {product.type === 'hose' ? 'feet' : 'unit'}
               </Typography>
               <Typography
                  sx={{
                     fontWeight: '600',
                     color: 'grey'
                  }}
               >
                  {'Subtotal: $'}
                  {product.type === 'hose'
                     ? (
                          parseFloat(product.lPrice) *
                          (parseFloat(product.qty.split('-')[0]) +
                             parseFloat(product.qty.split('-')[1]) / 12)
                       ).toFixed(2)
                     : (parseFloat(product.lPrice) * parseFloat(product.qty)).toFixed(2)}
               </Typography>
            </Box>
            <Button className='product-actions' item='true' onClick={removeProduct}>
               <Cross color='action' fontSize='large' />
            </Button>
         </Box>
      </Box>
   )
}

export default MobileCartProduct
